import React, { useEffect, useMemo, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Drawer, Dropdown, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { toast } from "react-toastify";
import TopBar from "../../components/topbar/topbar";
import Footer from "../../components/footer/footer";
import SubMenu from "../../components/sub-menu/sub-menu";
import "./consult-astrology.scss";
import Slider from "../../components/slider/slider";
import {
  getExperienceMiddleWare,
  getExpertiseMiddleWare,
  getLanguageMiddleWare,
  listAvailableAstrologersMiddleWare,
  testimonialAstrologersMiddleWare,
} from "./store/consultastrologyMiddleware";
import { setLoader } from "../../redux/store/commonReducer";
import useDebounce from "../../hooks/Debounce";
import { getUserId, scrollTop } from "../../utils/util";
import SvgSearch from "../../icons/SvgSearch";
import SvgSort from "../../icons/SvgSort";
import SvgClose from "../../icons/SvgClose";
import AndroidRedirectModal from "./AndroidRedirectModal";
import Appstore from "../../assets/icons/appstore.webp";
import Google from "../../assets/icons/googleplay.webp";
import AstroCardRender from "./AstroCardRender";
import LoginModal from "../../components/topbar/LoginModal";

export const PAGE_SIZE_ASTRO = 6;
export const PAGE_SIZE_ASTRO_MOBILE = 5;

export const PAGE_SIZE_ASTRO_INITIAL = 3;
export const PAGE_SIZE_ASTRO_MOBILE_INITIAL = 1;

export const getValue = (data, id) => {
  return data?.filter((list) => list.key === id)[0];
};

const mapStateToProps = (state) => {
  const {
    getExperienceReducers,
    getExpertiseReducers,
    getLanguageReducers,
    astrocureTestimonialReducers,
  } = state;
  return {
    getExperience: getExperienceReducers?.data?.data,
    getExpertise: getExpertiseReducers?.data?.data,
    getLanguage: getLanguageReducers?.data?.data,
    astroTestimonial: astrocureTestimonialReducers?.data?.data,
  };
};

const ConsultAstrologyScreen = ({
  getExperience,
  getExpertise,
  getLanguage,
  astroTestimonial,
}) => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState(null);
  const [sort, setSort] = useState(null);
  const [lang, setLang] = useState(null);
  const navigate = useNavigate();
  const [topRateData, setTopRateData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebounce(searchValue, 500);
  const [pageno, setPageno] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [isLoad, setLoad] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1019px)" });
  const [isDrawerLanguage, setDrawerLanguage] = useState(false);
  const [isDrawerSort, setDrawerSort] = useState(false);
  const [isDrawerExpertise, setDrawerExpertise] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [isRedirect, setRedirect] = useState(false);
  const [isInitial, setInitial] = useState(true);
  const isDispatched = useRef(false);
  const [loginModalVisible, setLoginModalVisible] = useState(false);

  let pageSize;

  if (isTabletOrMobile) {
    if (isInitial) {
      pageSize = PAGE_SIZE_ASTRO_MOBILE_INITIAL;
    } else {
      pageSize = PAGE_SIZE_ASTRO_MOBILE;
    }
  } else if (isInitial) {
    pageSize = PAGE_SIZE_ASTRO_INITIAL;
  } else {
    pageSize = PAGE_SIZE_ASTRO;
  }

  const pageLimit = Math.ceil(totalPage?.astrologersCount / pageSize);

  const payload = {
    user_id: getUserId(),
    searchValue: "",
    expertise: "",
    experience: "",
    availability: 1,
    star_rating: 0,
    language: "",
    page_no: 0,
    limit: pageSize,
    sort_by: "",
  };

  const getAvailableAstrologers = (payload, isfilter) => {
    setLoad(true);
    dispatch(
      listAvailableAstrologersMiddleWare({
        payload,
      })
    )
      .then((res) => {
        if (res.payload.response?.status === 400) {
          toast.error(res.payload.response.data.alert, {
            position: "top-center",
          });
          setTopRateData([]);
        }

        const removeDuplicates = (data) => {
          const uniqueIds = new Set();
          return data.filter((item) => {
            if (!uniqueIds.has(item._id)) {
              uniqueIds.add(item._id);
              return true;
            }
            return false;
          });
        };

        if (isfilter) {
          setTopRateData(res.payload?.data);
        } else {
          setTopRateData((pre) => [
            ...pre,
            ...removeDuplicates(res.payload?.data),
          ]);
        }
        setTotalPage(res.payload?.additionalData || 0);
      })
      .finally(() => setLoad(false));
  };

  useEffect(() => {
    if (!isDispatched.current) {
      dispatch(setLoader(true));
      dispatch(getExperienceMiddleWare())
        .finally(() => {
          dispatch(getExpertiseMiddleWare());
        })
        .finally(() => {
          dispatch(getLanguageMiddleWare()).finally(() => {
            dispatch(setLoader(false));
          });
        });

      getAvailableAstrologers(payload, true);
      getTestimonial();
      isDispatched.current = true;
    }
  }, []);

  useEffect(() => {
    if (!getUserId()) {
      setLoginModalVisible(true);
    }
  }, []);

  const categoryData = useMemo(() => {
    return getExpertise?.map((list) => {
      return { key: list._id, label: list.dataName };
    });
  }, [getExpertise]);

  const langData = useMemo(() => {
    return getLanguage?.map((list) => {
      return { key: list._id, label: list.dataName };
    });
  }, [getLanguage]);

  const sortData = useMemo(() => {
    return getExperience?.map((list) => {
      return { key: list._id, label: list.dataName };
    });
  }, [getExperience]);

  const handleSearch = (search) => {
    dispatch(setLoader(true));
    dispatch(
      listAvailableAstrologersMiddleWare({
        payload: { ...payload, searchValue: search },
      })
    )
      .then((res) => {
        setTopRateData(res.payload?.data);
      })
      .finally(() => dispatch(setLoader(false)));
  };

  useEffect(() => {
    handleSearch(debouncedSearchValue);
  }, [debouncedSearchValue]);

  const getTestimonial = () => {
    dispatch(setLoader(true));
    dispatch(testimonialAstrologersMiddleWare()).finally(() =>
      dispatch(setLoader(false))
    );
  };

  const image_container =
    astroTestimonial &&
    astroTestimonial
      .filter((item) => {
        return item.userId && item.userId.profileUrl;
      })
      .map((item) => item.userId.profileUrl)
      .slice(0, 5);

  const handleReset = () => {
    setCategory(null);
    setSort(null);
    setLang(null);
    setSearchValue("");
    setPageno(0);
    getAvailableAstrologers(payload, true);
  };

  const handleMoreMobile = (getPage) => {
    setPageno(getPage);
    setLoad(true);
    getAvailableAstrologers(
      {
        ...payload,
        expertise: category ?? "",
        language: lang ?? "",
        experience: sort ?? "",
        page_no: getPage,
      },
      false
    );
  };

  const handleConnect = (item) => {
    if (isTabletOrMobile) {
      window.open(window.location.href + `?id=${item?._id}`);
    } else {
      setRedirect(true);
    }
  };

  const handleInitial = () => {
    setInitial(true);
    getAvailableAstrologers(
      {
        ...payload,
        limit: isTabletOrMobile
          ? PAGE_SIZE_ASTRO_MOBILE_INITIAL
          : PAGE_SIZE_ASTRO_INITIAL,
      },
      true
    );
    setTimeout(() => {
      scrollTop();
    }, 100);
  };

  const handleInitialFalse = () => {
    setInitial(false);
    getAvailableAstrologers(
      {
        ...payload,
        limit: isTabletOrMobile ? PAGE_SIZE_ASTRO_MOBILE : PAGE_SIZE_ASTRO,
      },
      true
    );
    setTimeout(() => {
      scrollTop();
    }, 100);
  };

  useEffect(() => {
    if (isInitial) {
      getAvailableAstrologers(
        {
          ...payload,
          page_no: pageno,
          limit: isTabletOrMobile
            ? PAGE_SIZE_ASTRO_MOBILE_INITIAL
            : PAGE_SIZE_ASTRO_INITIAL,
        },
        true
      );
    }
  }, [pageno, isInitial]);

    const handleGetKundali = () => {
      setInitial(false);
      setTimeout(() => {
        scrollTop();
      }, 200);
    };

  return (
    <div className="topDiv topDiv-astro">
      {loginModalVisible && (
        <LoginModal
          open={loginModalVisible}
          onHide={() => setLoginModalVisible(false)}
          handleGetKundali={handleGetKundali}
        />
      )}
      <AndroidRedirectModal
        open={isRedirect}
        close={() => setRedirect(false)}
      />
      {isTabletOrMobile && (
        <>
          <Drawer
            title="Expertise"
            placement={"bottom"}
            closable={false}
            onClose={() => setDrawerExpertise(false)}
            open={isDrawerExpertise}
            styles={{
              header: {
                borderRadius: 20,
              },
            }}
            extra={
              <div onClick={() => setDrawerExpertise(false)}>
                <SvgClose />
              </div>
            }
          >
            {categoryData?.map((list) => {
              return (
                <div
                  key={list.key}
                  onClick={() => {
                    setCategory(list.key);
                    getAvailableAstrologers(
                      {
                        ...payload,
                        expertise: list.key,
                        language: lang ?? "",
                        experience: sort ?? "",
                      },
                      true
                    );
                    setDrawerExpertise(false);
                  }}
                  className="category-list-mobile dropdown-option"
                >
                  <input
                    checked={category === list.key}
                    type="radio"
                    name="astroSelectTwo"
                  />
                  <p>{list.label}</p>
                </div>
              );
            })}
          </Drawer>

          <Drawer
            title="Expertise"
            placement={"bottom"}
            closable={false}
            onClose={() => setDrawerLanguage(false)}
            open={isDrawerLanguage}
            styles={{
              header: {
                borderRadius: 20,
              },
            }}
            extra={
              <div onClick={() => setDrawerLanguage(false)}>
                <SvgClose />
              </div>
            }
          >
            {langData?.map((list) => {
              return (
                <div
                  onClick={() => {
                    setLang(list.key);
                    getAvailableAstrologers(
                      {
                        ...payload,
                        language: list.key,
                        expertise: category ?? "",
                        experience: sort ?? "",
                      },
                      true
                    );
                    setDrawerLanguage(false);
                  }}
                  className="category-list-mobile dropdown-option"
                >
                  <input
                    checked={lang === list.key}
                    type="radio"
                    name="astroSelectTwo"
                  />
                  <p>{list.label}</p>
                </div>
              );
            })}
          </Drawer>

          <Drawer
            title="Expertise"
            placement={"bottom"}
            closable={false}
            onClose={() => setDrawerSort(false)}
            open={isDrawerSort}
            styles={{
              header: {
                borderRadius: 20,
              },
            }}
            extra={
              <div onClick={() => setDrawerSort(false)}>
                <SvgClose />
              </div>
            }
          >
            {sortData?.map((list) => {
              return (
                <div
                  onClick={() => {
                    setSort(list.key);
                    getAvailableAstrologers(
                      {
                        ...payload,
                        experience: list.key,
                        language: lang ?? "",
                        expertise: category ?? "",
                      },
                      true
                    );
                    setDrawerSort(false);
                  }}
                  className="category-list-mobile dropdown-option"
                >
                  <input
                    checked={sort === list.key}
                    type="radio"
                    name="astroSelectTwo"
                  />
                  <p>{list.label}</p>
                </div>
              );
            })}
          </Drawer>
        </>
      )}
      <TopBar
        handleReset={() => {
          setInitial(true);
        }}
      />
      <div className="consult-astro-container">
        <SubMenu handleRest={handleInitial} />
        {isInitial ? (
          <div className="feeling-overAll">
            <div className="feeling-div">
              <div className="feeling-text-div">
                <span className="feeling-text">Feeling</span>
                <span className="confused-text">Confused and Lost</span>
                <span className="life-text">with your Life?</span>
                <span className="experts-text">
                  Get guidance from experts. 
                </span>
                <button 
                 onClick={() => {
                  if (getUserId()) {
                    handleInitialFalse();
                  } else {
                    setLoginModalVisible(true);
                  }
                }}
                className="connect-btn">
                  Connect with an Astrologer
                </button>
              </div>
              <div className="feeling-image-div">
                <img
                  src={require("../../assets/images/connect-astro.webp")}
                  alt="lang"
                />
              </div>
            </div>
            <div className="book-an-astrologer-div">
              <span className="book-an-text">Connect an Astrologer</span>
              <div className="category-sections">
                <div className="card-listing">
                  {topRateData && (
                    <AstroCardRender
                      handleConnect={handleConnect}
                      handleMore={handleMoreMobile}
                      data={topRateData}
                      navigate={navigate}
                      handlePage={setPageno}
                      pageno={pageno}
                      isCarosel
                      pageLimit={pageLimit}
                      isLoad={isLoad}
                      isMobile={false}
                    />
                  )}
                </div>
              </div>
              <button
                 onClick={() => {
                  if (getUserId()) {
                    handleInitialFalse();
                  } else {
                    setLoginModalVisible(true);
                  }
                }}
                className="see-more-astro-btn"
              >
                See More Astrologer
              </button>
            </div>

            <div className="expect-session-div">
              <span className="expect-session-text">
                What can you expect from a session with our <br />
                Astrologers?
              </span>
              <span className="find-answers-text">
                Find Answers Across Categories
              </span>
              <div className="list-astro-div">
                <img
                  src={require("../../assets/images/career-astro.webp")}
                  alt="lang"
                />
                <img
                  src={require("../../assets/images/love-astro.webp")}
                  alt="lang"
                />
                <img
                  src={require("../../assets/images/education-astro.webp")}
                  alt="lang"
                />
                <img
                  src={require("../../assets/images/family-astro.webp")}
                  alt="lang"
                />
                <img
                  src={require("../../assets/images/relationships-astro.webp")}
                  alt="lang"
                />
                <img
                  src={require("../../assets/images/health-astro.webp")}
                  alt="lang"
                />
              </div>
            </div>
            <div className="difficult-box">
              <div className="difficult-image-div">
                <img
                  src={require("../../assets/images/difficult.webp")}
                  alt="lang"
                />
              </div>
              <div className="difficult-text-div">
                <span>
                  Life can get difficult at times. You can feel lost - be it in
                  your career, health, or even when choosing your life partner.
                  However, seeking astrological guidance based on Vedic studies
                  can provide you a sense of direction and clarity to move
                  forward. Our expert and hand-picked astrologers analyse the
                  planetary positions and guide you to turn the tide and welcome
                  the good times.
                </span>
              </div>
            </div>
            <div className="download-app-box">
              <span className="get-personalized-text">
                Get Personalized Guidance from our Expert and Hand-picked
                Astrologers 
              </span>
              <span className="download-app-text">Download the App Now</span>
              <div className="app-img-div">
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    (window.location.href =
                      "https://astrocure.co.in/coming-soon/")
                  }
                  src={Appstore}
                  alt="lang"
                />
                <img src={Google} alt="lang"
                              onClick={() =>
                (window.location.href =
                "https://play.google.com/store/apps/details?id=com.astrocure")
                }
                 />
              </div>
            </div>
          </div>
        ) : (
          <>
            {isTabletOrMobile && (
              <div className="consult-footer">
                <div
                  onClick={() => {
                    setSearch(true);
                    scrollTop();
                  }}
                  className="footer-btn-div"
                >
                  <SvgSearch />
                  <span>Search</span>
                </div>

                <div className="line" />
                <div
                  onClick={() => {
                    setDrawerExpertise(true);
                    scrollTop();
                  }}
                  className="footer-btn-div"
                >
                  <span>Expertise</span>
                </div>
                <div className="line" />
                <div
                  onClick={() => {
                    setDrawerLanguage(true);
                    scrollTop();
                  }}
                  className="footer-btn-div"
                >
                  <span>Language</span>
                </div>
                <div className="line" />
                <div
                  onClick={() => {
                    setDrawerSort(true);
                    scrollTop();
                  }}
                  className="footer-btn-div"
                >
                  <SvgSort />
                  <span>Sort by</span>
                </div>
              </div>
            )}
            {isSearch && isTabletOrMobile && (
              <div className="filter-bar">
                <div className="search-bar">
                  <img
                    src={require("../../assets/svgs/search.svg").default}
                    alt="lang"
                  />
                  <Input
                    placeholder="Search by name"
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                  />
                </div>
              </div>
            )}
            <div className="header">
              <h1>Choose Your Astrologer</h1>
            </div>
            {!isTabletOrMobile && (
              <div className="filter-bar">
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <div style={{ marginRight: 10 }} className="search-bar">
                    <img
                      src={require("../../assets/svgs/search.svg").default}
                      alt="lang"
                    />
                    <Input
                      placeholder="Search by name"
                      value={searchValue}
                      onChange={(event) => setSearchValue(event.target.value)}
                    />
                  </div>
                  <div style={{ gap: 10 }} className="other-bar">
                    <Dropdown
                      className="dropdown-class"
                      menu={{
                        items: categoryData,
                        onClick: (value) => {
                          setCategory(value.key);
                          getAvailableAstrologers(
                            {
                              ...payload,
                              expertise: value.key,
                              language: lang ?? "",
                              experience: sort ?? "",
                            },
                            true
                          );
                        },
                      }}
                      trigger={["click"]}
                      placement="bottomLeft"
                    >
                      <button className="d-flex">
                        {getValue(categoryData, category)?.label
                          ? getValue(categoryData, category)?.label
                          : "Expertise"}
                        <img
                          className="down-arrow"
                          src={
                            require("../../assets/svgs/dropArrow.svg").default
                          }
                          alt="lang"
                        />
                      </button>
                    </Dropdown>
                    <Dropdown
                      className="dropdown-class"
                      menu={{
                        items: langData,
                        onClick: (value) => {
                          setLang(value.key);
                          getAvailableAstrologers(
                            {
                              ...payload,
                              language: value.key,
                              expertise: category ?? "",
                              experience: sort ?? "",
                            },
                            true
                          );
                        },
                      }}
                      trigger={["click"]}
                      placement="bottomLeft"
                    >
                      <button className="d-flex">
                        {getValue(langData, lang)?.label
                          ? getValue(langData, lang)?.label
                          : "Language"}
                        <img
                          className="down-arrow"
                          src={
                            require("../../assets/svgs/dropArrow.svg").default
                          }
                          alt="lang"
                        />
                      </button>
                    </Dropdown>
                  </div>
                </div>
                <div className="other-bar">
                  <Dropdown
                    className="dropdown-class"
                    menu={{
                      items: sortData,
                      onClick: (value) => {
                        setSort(value.key);
                        getAvailableAstrologers(
                          {
                            ...payload,
                            experience: value.key,
                            language: lang ?? "",
                            expertise: category ?? "",
                          },
                          true
                        );
                      },
                    }}
                    trigger={["click"]}
                    placement="bottomLeft"
                  >
                    <button className="d-flex">
                      {getValue(sortData, sort)?.label
                        ? getValue(sortData, sort)?.label
                        : "Sort by : Experience"}
                      <img
                        className="down-arrow"
                        src={require("../../assets/svgs/dropArrow.svg").default}
                        alt="lang"
                      />
                    </button>
                  </Dropdown>
                  <button
                    onClick={handleReset}
                    className="mar-lft-10 primary-btn reset-btn"
                  >
                    Reset
                  </button>
                </div>
              </div>
            )}

            <div className="category-sections">
              <div className="card-listing">
                {topRateData && (
                  <AstroCardRender
                    handleConnect={handleConnect}
                    handleMore={handleMoreMobile}
                    data={topRateData}
                    navigate={navigate}
                    handlePage={setPageno}
                    pageno={pageno}
                    isCarosel
                    pageLimit={pageLimit}
                    isLoad={isLoad}
                    isMobile
                  />
                )}
              </div>
            </div>

            <div className="header">
              <h1>Why Users Choose AstroCure</h1>
            </div>

            <div className="testimonial">
              <div className="sliders">
                <Slider slides={astroTestimonial} />
              </div>

              <div className="image-section">
                {image_container?.map((img, index) => (
                  <img
                    key={`img-sec-${index}`}
                    src={img}
                    className={`img-sec-${index}`}
                    alt="lang"
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
      {!isInitial && <div className="mobile-empty" />}{" "}
    </div>
  );
};

export default connect(mapStateToProps)(ConsultAstrologyScreen);
